import { createContext, useContext, useEffect, useState } from 'react';
import supabase from '../config/supabaseClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(localStorage.getItem('token') || null);

    const isTokenValid = Boolean(token);

    useEffect(() => {
        const checkSession = async () => {
            const {
                data: { session },
            } = await supabase.auth.getSession();
            if (session) {
                setToken(session.access_token);
                localStorage.setItem('token', session.access_token);
            } else {
                setToken(null);
                localStorage.removeItem('token');
            }
        };
        checkSession();
    }, []);

    const logout = async () => {
        await supabase.auth.signOut();
        localStorage.removeItem('token');
        setToken(null);
    };

    return (
        <AuthContext.Provider value={{ token, setToken, isTokenValid, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);